import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-size",
  "use": "icon-size-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-size\"><path d=\"M.56 438.936h437.889v146.128h-145.96v438.376H146.52V585.064H.56V438.936zm1021.737-292.248H735.236v876.752H579.574V146.688H292.512V.56h729.81l-.025 146.128z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol